// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Logirent-Regular-Demo.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
  margin: 0;
  background-color: #f8f9fa;
}

.gapsy-login_leftSection__Z-DW- {
  background: linear-gradient(to bottom right, #48a7df, #91d7f1);
  color: #ffffff;
  height: 100vh;
  display: flex;
  justify-content: center;
  /* Horizontal centering */
  align-items: center;
  /* Vertical centering */
  text-align: center;
  padding: 2rem;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

#gapsy-login_root__oyVe1 {
  height: 100%;
}

.gapsy-login_lead__GRErI {
  font-size: 12px;
}

@keyframes gapsy-login_gradientBG__5px-Z {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.gapsy-login_rightSection__T6sbI {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 2rem;
}

.gapsy-login_loginForm__ZL3gW {
  width: 100%;
  max-width: 400px;
  background-color: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.07);
  border: 1px solid #dee2e6;
}

.gapsy-login_btnGradient__Kbj59 {
  background: linear-gradient(45deg, #1976d2, #64b5f6);
  border: none;
  color: #ffffff;
  transition: 0.3s ease;
}

.gapsy-login_btnGradient__Kbj59:hover {
  opacity: 0.95;
}

.gapsy-login_inputGroupText__9dWDj {
  background-color: #f1f1f1;
}

@font-face {
  font-family: 'Logirent Demo';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  /* format should be 'truetype' for .ttf files */
}

.gapsy-login_h2LogoFont__ARc2d {
  font-family: 'Logirent Demo', sans-serif !important;
  font-size: 2rem;
  font-weight: 700;
  color: #163f66;
}

.gapsy-login_leftSection__Z-DW- h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #163f66;
  /* Dark blue text for logo title */
}

.gapsy-login_leftSection__Z-DW- h3 {
  font-size: 1.5rem;
  margin-top: 1rem;
  color: #1c3d5a;
  /* Match the logo theme */
}

.gapsy-login_leftSection__Z-DW- p {
  font-size: 1rem;
  color: #2d4d6d;
  /* Slightly darker tone for readability */
}

.gapsy-login_rightSection__T6sbI>label,
.gapsy-login_rightSection__T6sbI>i {
  color: #495057;
}

@media (max-width: 768px) {

  .gapsy-login_leftSection__Z-DW-,
  .gapsy-login_rightSection__T6sbI {
    height: auto;
    padding: 2rem 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/gapsy-login.module.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,8DAA8D;EAC9D,cAAc;EACd,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,+DAAgE;EAChE,+CAA+C;AACjD;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE;;IAEE,YAAY;IACZ,kBAAkB;EACpB;AACF","sourcesContent":["html,\r\nbody {\r\n  height: 100%;\r\n  margin: 0;\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.leftSection {\r\n  background: linear-gradient(to bottom right, #48a7df, #91d7f1);\r\n  color: #ffffff;\r\n  height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  /* Horizontal centering */\r\n  align-items: center;\r\n  /* Vertical centering */\r\n  text-align: center;\r\n  padding: 2rem;\r\n  border-top-left-radius: 12px;\r\n  border-bottom-left-radius: 12px;\r\n}\r\n\r\n#root {\r\n  height: 100%;\r\n}\r\n\r\n.lead {\r\n  font-size: 12px;\r\n}\r\n\r\n@keyframes gradientBG {\r\n  0% {\r\n    background-position: 0% 50%;\r\n  }\r\n\r\n  50% {\r\n    background-position: 100% 50%;\r\n  }\r\n\r\n  100% {\r\n    background-position: 0% 50%;\r\n  }\r\n}\r\n\r\n.rightSection {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100vh;\r\n  padding: 2rem;\r\n}\r\n\r\n.loginForm {\r\n  width: 100%;\r\n  max-width: 400px;\r\n  background-color: #fff;\r\n  padding: 2rem;\r\n  border-radius: 12px;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.07);\r\n  border: 1px solid #dee2e6;\r\n}\r\n\r\n.btnGradient {\r\n  background: linear-gradient(45deg, #1976d2, #64b5f6);\r\n  border: none;\r\n  color: #ffffff;\r\n  transition: 0.3s ease;\r\n}\r\n\r\n.btnGradient:hover {\r\n  opacity: 0.95;\r\n}\r\n\r\n.inputGroupText {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Logirent Demo';\r\n  src: url('./fonts/Logirent-Regular-Demo.ttf') format('truetype');\r\n  /* format should be 'truetype' for .ttf files */\r\n}\r\n\r\n.h2LogoFont {\r\n  font-family: 'Logirent Demo', sans-serif !important;\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: #163f66;\r\n}\r\n\r\n.leftSection h2 {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: #163f66;\r\n  /* Dark blue text for logo title */\r\n}\r\n\r\n.leftSection h3 {\r\n  font-size: 1.5rem;\r\n  margin-top: 1rem;\r\n  color: #1c3d5a;\r\n  /* Match the logo theme */\r\n}\r\n\r\n.leftSection p {\r\n  font-size: 1rem;\r\n  color: #2d4d6d;\r\n  /* Slightly darker tone for readability */\r\n}\r\n\r\n.rightSection>label,\r\n.rightSection>i {\r\n  color: #495057;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\r\n  .leftSection,\r\n  .rightSection {\r\n    height: auto;\r\n    padding: 2rem 1rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftSection": `gapsy-login_leftSection__Z-DW-`,
	"root": `gapsy-login_root__oyVe1`,
	"lead": `gapsy-login_lead__GRErI`,
	"rightSection": `gapsy-login_rightSection__T6sbI`,
	"loginForm": `gapsy-login_loginForm__ZL3gW`,
	"btnGradient": `gapsy-login_btnGradient__Kbj59`,
	"inputGroupText": `gapsy-login_inputGroupText__9dWDj`,
	"h2LogoFont": `gapsy-login_h2LogoFont__ARc2d`,
	"gradientBG": `gapsy-login_gradientBG__5px-Z`
};
export default ___CSS_LOADER_EXPORT___;
